<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:left_view>
      <div>
        <topo-tree
          :message="receiveGraphNeID"
          :searchBox="searchBox"
          :checkBox="checkBox"
          @sendInfo="receiveTreeMessage"
        ></topo-tree>
      </div>
    </template>
    <template v-slot:right_view>
      <div>
        <button-graph
          ref="baseBtn"
          @notice="notice"
          :saveLocBtn="true"
          :layoutBtn="true"
          :selectAllBtn="true"
          :revertBtn="true"
          :fullScreenBtn="true"
          :backPreBtn="true"
        ></button-graph>
        <base-logic
          ref="baseObj"
          :nodes="nodes"
          :nodesMap="nodesMap"
          :slecteMessage="slecteMessage"
          :message="receiveTreeNeID"
          @sendInfo="receiveGraphMessage"
          @changeNode="changeNode"
        ></base-logic>
      </div>
    </template>
  </BasicLayout>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import BasicLayout from '../../../layouts/BasicLayout';
import TopoTree from '@/components/topoconfig/TopoTree';
import BaseLogic from '@/components/topoconfig/BaseLogic';
import ButtonGraph from '@/components/topoconfig/ButtonGraph';
import topoMethods from '@/components/topoconfig/TopoCommon';

const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

export default {
  name: 'LogicalGraph',
  components: {
    BasicLayout,
    TopoTree,
    ButtonGraph,
    BaseLogic
  },
  props: ['slecteMessage'],
  mixins: [topoMethods],
  mounted() {
    window.onresize = () => {
      // 全屏状态下监听esc事件
      if (!this.checkFull()) {
        this.$parent.menuControl(0);
        this.flag = 1;
        this.$refs.baseBtn.flag = this.flag;
      }
    };
  },
  created() {
    const isLogical = true;
    this.axios.get('lte/ems/topo/treeData.html', JSON.stringify(isLogical)).then((response) => {
      // const that = this;
      response.data.resultVal.forEach(element => {
        const node = this.createElement(element.type, element);
        if (element.parentid === '' || element.parentid == null) {
          this.nodes.push(node);
        }
        this.nodesMap.set(node.id, node);
      });
      if (this.nodesMap.size > 0) {
        this.setPhysical(this.nodesMap);
      }
    });
  },
  data() {
    return {
      left: {
        show: true,
        name: '网元树'
      },
      middle: {
        show: false,
        name: 'mo'
      },
      right: {
        show: true,
        crumb: '拓扑管理 / 逻辑图'
      },

      searchBox: {
        show: true
      },
      checkBox: {
        show: false
      },
      receiveTreeNeID: 22222,
      receiveGraphNeID: 33333,
      nodes: [],
      nodesGrage: [], // 双击网元进入下一层缓存标志
      nodesCache: [], // 双击网元缓存当前层网元
      nodesMap: new Map(),
      flag: 1
    };
  },
  computed: {
    ...mapGetters(['logicalNodes', 'getTypeByCode', 'getTopoGraph'])
  },
  methods: {
    ...mapActions(['setLogical']),
    receiveTreeMessage(treeNeID) {
      // console.log('treeNeID', treeNeID);
      this.receiveTreeNeID = treeNeID;
      this.$emit('sendInfo', treeNeID);
    },
    receiveGraphMessage(graphNeID) {
      // console.log('graphNeID', graphNeID);
      this.receiveGraphNeID = graphNeID;
    },
    changeNode(nodesList) {
      this.nodes = [];
      this.nodes = nodesList;
    },
    notice(type) {
      switch (type) {
        case 'saveLocBtn': // 保存位置
          this.saveLoc();
          break;
        case 'excelLayout': // 布局排序
          this.excelLayout();
          break;
        case 'revertScale': // 返回1:1
          this.revert();
          break;
        case 'fullScreen': // 全屏
          this.fullScreen();
          break;
        case 'selectAll': // 全选
          this.selectAll();
          break;
        case 'backPrevious': // 返回上级
          this.backPrevious();
          break;
        default:
          break;
      }
    },
    saveLoc() {
      this.$refs.baseObj.saveLoc();
    },
    excelLayout() {
      this.$refs.baseObj.excelLayout();
    },
    revert() {
      this.$refs.baseObj.revert();
    },
    selectAll() {
      this.$refs.baseObj.selectAll();
    },
    // 返回上一层
    backPrevious() {
      this.$refs.baseObj.backPrevious();
    },
  }
};
</script>

<style>
</style>
